module.exports = __webpack_public_path__ + "img/coating-water-cover.f8172b3f.png";